import { E as c } from "./keys-KoEjL9PG.js";
import { h } from "./lifecycle-decorators-C04d1yHY.js";
var y = (l, e, t, n) => {
  for (var r = e, o = l.length - 1, a; o >= 0; o--)
    (a = l[o]) && (r = a(r) || r);
  return r;
};
function I(l) {
  let e = class extends l {
    /**
     * Keyboard event handler for arrow control. Uses the element that we are currently
     * focused on to find order which removes any complexity that comes from tracking
     * the current index.
     *
     * To use the mixin, attach this event listener to each of the events to be
     * controlled with arrow control, then pass an array of those elements as arrowControlElements
     *
     * @param event
     * @param arrowControlElements elements to move focus between, in order
     * @param layoutDirection 'horizontal', 'vertical', or 'any' depending on which arrow keys should be used
     * @param focusCallback callback to when an element is focused. Allows element to autoselect or defer focus to a child
     */
    handleArrowControlKeydown(t, n, r, o) {
      let a = !1;
      if (t && t.isTrusted) {
        const u = e.calculateArrowIncrement(
          t,
          r
        );
        if (u != 0) {
          const i = n.indexOf(
            t.currentTarget
          );
          if (i != -1) {
            const s = e.ensureFocusIndexInRange(
              i + u,
              n.length
            );
            o.call(this, n[s]), a = !0;
          }
        }
      }
      return a;
    }
    /**
     * Calculates the index increment based on the input keys.
     * @param event
     * @param layoutDirection
     * @returns
     */
    static calculateArrowIncrement(t, n) {
      return t.key === c.LEFT && (n === "horizontal" || n === "any") || t.key === c.UP && (n === "vertical" || n === "any") ? -1 : t.key === c.RIGHT && (n === "horizontal" || n === "any") || t.key === c.DOWN && (n === "vertical" || n === "any") ? 1 : 0;
    }
    /**
     * Wraps the focus index around the ends of the array
     * @param focusIndex
     * @param numberOfElements
     * @returns
     */
    static ensureFocusIndexInRange(t, n) {
      return t < 0 ? n - 1 : t >= n ? 0 : t;
    }
  };
  return e = y([
    h("ArrowControl")
  ], e), e;
}
export {
  I as h
};
